export type UpdateComponentDeploymentRequestsResponse = {
  warningMessage: string[] | null;
};
